// extracted by mini-css-extract-plugin
export default {"sideNav":"style_sideNav__JPmJ1","pagesContainer":"style_pagesContainer__8+lP9","fadeIn":"style_fadeIn__UsSST","logout":"style_logout__-UYSh"};